import { render, staticRenderFns } from "./Button.htm?vue&type=template&id=58e1c1af&scoped=true&"
import script from "./Button.js?vue&type=script&lang=js&"
export * from "./Button.js?vue&type=script&lang=js&"
import style0 from "./Button.scss?vue&type=style&index=0&id=58e1c1af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e1c1af",
  null
  
)

export default component.exports